/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface DeleteQualitySectionConfig$Params {
  qualitySectionConfigId: string;
}

export function deleteQualitySectionConfig(
  http: HttpClient,
  rootUrl: string,
  params: DeleteQualitySectionConfig$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteQualitySectionConfig.PATH, 'delete');
  if (params) {
    rb.path('qualitySectionConfigId', params.qualitySectionConfigId, {});
  }

  return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteQualitySectionConfig.PATH = '/admin/quality-section-config/{qualitySectionConfigId}';
